import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Menu } from 'antd';
import './index.less';
import { SoilProfileDropDownIcon, SoilProfileExpandIcon } from '@/resource/IconComponentSets';
import { IUserManagementSearchModel } from '@/util/Request/requestType';

interface IProps {
  title: string,
  selectors?: string[]
  selectorsObj?: IUserManagementSearchModel[]
  selectValueCallback?: (value: string, index: number) => void
  selectValueObjCallback?: (value: IUserManagementSearchModel) => void
  enable?: boolean
  value?: string
  defaultText?: string
  style?: React.CSSProperties,
  className?: string
  type?: 'dropdown' | 'input-dropdown'
}

export default function SoilDropDown (props: IProps) {
    const {
        title,
        selectors,
        selectorsObj,
        selectValueCallback,
        selectValueObjCallback,
        enable = true,
        value,
        defaultText,
        style,
        className,
        type = 'dropdown'
    } = props;
    // const [selected, setSelectedVaue] = useState<string | undefined>(defaultText);
    const [menuVisible, setMenuVisible] = useState(false);
    const [menusArr, setMenuArr] = useState([]);

    const [inputValue, setInputValue] = useState('');

    const selectTargetValue = (item: string, index: number) => {
        selectValueCallback && selectValueCallback(item, index);
        // if the value had been selected, the menu should be hide
        // setSelectedVaue(item);
        setMenuVisible(false);
    };

    const selectTargetObjValue = (item: IUserManagementSearchModel) => {
        selectValueObjCallback && selectValueObjCallback(item);
        setMenuVisible(false);
    };

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    useEffect(() => {
        if (type === 'dropdown') {
            const menusArrLocal = selectors.map((item, index) => {
                return { label: item, key: `item-${index}`, onClick: () => selectTargetValue(item, index) };
            });
            setMenuArr(menusArrLocal);
        } else {
            const menusArrLocal = selectorsObj .map((item, index) => {
                return { label: item.userDisplayName, key: `item-${index}`, target: item, onClick: () => selectTargetObjValue(item) };
            });
            setMenuArr(menusArrLocal);
        }

    }, [selectors, selectorsObj]);

    useEffect(() => {
        if (type === 'input-dropdown') {
            if (inputValue.length !== 0) {
                const result = selectorsObj.filter((select) => {
                    const include = select.userDisplayName.toUpperCase().includes(inputValue.toUpperCase());
                    return include;
                });
                const menusArrLocal = result.map((item, index) => {
                    return { label: item.userDisplayName, key: `item-${index}`, target: item, onClick: () => selectTargetObjValue(item) };
                });
                setMenuArr(menusArrLocal);
            } else {
                const menusArrLocal = selectorsObj.map((item, index) => {
                    return { label: item.userDisplayName, key: `item-${index}`, target: item, onClick: () => selectTargetObjValue(item) };
                });
                setMenuArr(menusArrLocal);
            }
        }
    }, [inputValue]);

    return (
        <div className={`drop-down-container ${!enable && 'soil-drop-down-gray-color'}`}>
            <span>{title}</span>
            <div className='select-div'>
                <Dropdown
                    placement='bottomLeft'
                    overlay={<Menu items={menusArr} />}
                    trigger={['click']}
                    disabled={!enable}
                    overlayStyle={style}
                    onOpenChange={(visible) => {
                        setMenuVisible(visible);
                    }}>
                    {
                        type === 'dropdown' ? (
                            <a
                                onClick={e => e.preventDefault()}
                                className={`drop-dwon-input-box  ${menuVisible ? 'selecting-background' : 'selected-background'}  ${className}`}>
                                <span className={enable ? '' : 'select-value-show'}>
                                    {value ? value : defaultText}
                                </span>
                                {menuVisible ? (
                                    <SoilProfileDropDownIcon className='drop-down-icon' />
                                ) : (
                                    <SoilProfileExpandIcon className='drop-down-icon' />
                                )}
                            </a>
                        ) : (
                            <a
                                onClick={e => e.preventDefault()}
                                className={`drop-dwon-input-box  ${menuVisible ? 'selecting-background' : 'selected-background'}  ${className}`}
                            >
                                <input
                                    value={inputValue}
                                    onChange={(e) => {
                                        setInputValue(e.target.value);
                                    }}
                                    onClick={e => e.preventDefault()}
                                    onBlur={() => {
                                        if (!value || value.length === 0) {
                                            setInputValue(value);
                                        }
                                    }}
                                />
                                {menuVisible ? (
                                    <SoilProfileDropDownIcon className='drop-down-icon' />
                                ) : (
                                    <SoilProfileExpandIcon className='drop-down-icon' />
                                )}
                            </a>
                        )
                    }
                </Dropdown>
            </div>
        </div>
    );
}